import { gql } from '@apollo/client'
import { ID } from '../IQueryData'

export interface IGetTenantParkingPoolIdVars {
  tenant: string
}

export interface IGetTenantParkingPoolIdData {
  getTenant: {
    parkingPool?: {
      id: ID
    } | null
  } | null
}

export const GET_TENANT_PARKING_POOL_ID = gql`
  query getTenantParkingPoolId($tenant: String) {
    getTenant(name: $tenant) {
      parkingPool: parking_pool {
        id
      }
    }
  }
`
